// ============================================================================
// SITE CONFIGURATION
// ----------------------------------------------------------------------------
// عدّل بيانات التواصل والخدمات من هنا بسهولة.
// Edit contact details, services, and content from this single file.
// ============================================================================

export interface ContactInfo {
  brand: string
  slogan: string
  phoneDisplay: string
  phoneHref: string // digits only with country code, e.g. 967771234567
  whatsappDisplay: string
  whatsappNumber: string // digits only with country code
  email: string
  location: string
}

export interface ServiceItem {
  id: string
  title: string
  description: string
  icon: string // key from ServiceIcon map
}

export interface FeatureItem {
  title: string
  description: string
  icon: string
}

export interface ProcessStep {
  number: string
  title: string
}

export interface GalleryItem {
  src: string
  alt: string
}

// ----------------------------------------------------------------------------
// معلومات التواصل — عدّل الأرقام والبريد هنا
// CONTACT INFO — replace the placeholders below with your real details
// ----------------------------------------------------------------------------
export const contact: ContactInfo = {
  brand: 'أبو صالح النييفي للمقاولات',
  slogan: 'نبني بثقة... وننجز بجودة',
  phoneDisplay: '+967 7XX XXX XXX',
  phoneHref: '9677XXXXXXXX',
  whatsappDisplay: '+967 7XX XXX XXX',
  whatsappNumber: '9677XXXXXXXX',
  email: 'info@example.com',
  location: 'اليمن',
}

// ----------------------------------------------------------------------------
// أقسام التنقل
// ----------------------------------------------------------------------------
export const navLinks: { label: string; href: string }[] = [
  { label: 'الرئيسية', href: '#home' },
  { label: 'من نحن', href: '#about' },
  { label: 'خدماتنا', href: '#services' },
  { label: 'أعمالنا', href: '#gallery' },
  { label: 'طلب عرض سعر', href: '#quote' },
  { label: 'تواصل معنا', href: '#contact' },
]

// ----------------------------------------------------------------------------
// الخدمات
// ----------------------------------------------------------------------------
export const services: ServiceItem[] = [
  {
    id: 'general',
    title: 'المقاولات العامة',
    description: 'إدارة وتنفيذ مشاريع المقاولات بمختلف أنواعها من البداية حتى التسليم.',
    icon: 'building',
  },
  {
    id: 'houses',
    title: 'بناء المنازل',
    description: 'بناء المنازل والفلل بأسلوب هندسي دقيق يوازن بين المتانة والجمال.',
    icon: 'home',
  },
  {
    id: 'concrete',
    title: 'الأعمال الخرسانية',
    description: 'تنفيذ الأساسات والهياكل الخرسانية بجودة عالية ومطابقة للمواصفات.',
    icon: 'concrete',
  },
  {
    id: 'interior',
    title: 'التشطيبات الداخلية',
    description: 'تشطيبات داخلية عصرية تمنح المساحات لمسة أنيقة ومريحة.',
    icon: 'interior',
  },
  {
    id: 'exterior',
    title: 'التشطيبات الخارجية',
    description: 'واجهات ومداخل خارجية متينة وجذابة تعكس هوية المبنى.',
    icon: 'exterior',
  },
  {
    id: 'renovation',
    title: 'الترميم والصيانة',
    description: 'ترميم وصيانة المباني وإعادة تأهيلها بكفاءة وحرص على التفاصيل.',
    icon: 'renovation',
  },
  {
    id: 'tiling',
    title: 'البلاط والدهانات',
    description: 'تركيب البلاط وأعمال الدهانات بإتقان يبرز جمال كل مساحة.',
    icon: 'paint',
  },
  {
    id: 'mep',
    title: 'الكهرباء والسباكة',
    description: 'تمديدات كهربائية وأعمال سباكة آمنة ومنظمة وفق أفضل الممارسات.',
    icon: 'plumbing',
  },
  {
    id: 'projects',
    title: 'تنفيذ وتجهيز المشاريع',
    description: 'تنفيذ وتجهيز المشاريع المتكاملة بإشراف هندسي والتزام بالمواعيد.',
    icon: 'project',
  },
]

// ----------------------------------------------------------------------------
// لماذا نحن؟
// ----------------------------------------------------------------------------
export const features: FeatureItem[] = [
  { title: 'الجودة', description: 'الاهتمام بالتنفيذ والتفاصيل في كل مرحلة من مراحل العمل.', icon: 'quality' },
  { title: 'الالتزام', description: 'الالتزام بما يتم الاتفاق عليه مع العميل نصًا وروحًا.', icon: 'commit' },
  { title: 'الدقة', description: 'متابعة مراحل العمل بعناية لضمان دقة التنفيذ.', icon: 'precision' },
  { title: 'الشفافية', description: 'توضيح نطاق العمل والتكاليف للعميل بكل وضوح.', icon: 'transparency' },
]

// ----------------------------------------------------------------------------
// خطوات العمل
// ----------------------------------------------------------------------------
export const processSteps: ProcessStep[] = [
  { number: '01', title: 'التواصل معنا' },
  { number: '02', title: 'فهم احتياجات العميل' },
  { number: '03', title: 'معاينة المشروع' },
  { number: '04', title: 'تقديم عرض السعر' },
  { number: '05', title: 'بدء التنفيذ' },
  { number: '06', title: 'التسليم والمتابعة' },
]

// ----------------------------------------------------------------------------
// معرض الأعمال — نماذج توضيحية (قابلة للاستبدال بأعمالك الحقيقية)
// GALLERY — illustrative samples. Replace `src` with your own project photos.
// ----------------------------------------------------------------------------
export const gallery: GalleryItem[] = [
  { src: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80', alt: 'نموذج توضيحي لمشروع بناء' },
  { src: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80', alt: 'نموذج توضيحي لتشطيب داخلي' },
  { src: 'https://images.unsplash.com/photo-1590725140246-20acdee442be?auto=format&fit=crop&w=1200&q=80', alt: 'نموذج توضيحي لأعمال خرسانية' },
  { src: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1200&q=80', alt: 'نموذج توضيحي لواجهة مبنى' },
  { src: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80', alt: 'نموذج توضيحي لتشطيب غرفة' },
  { src: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=80', alt: 'نموذج توضيحي لموقع إنشاءات' },
  { src: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1200&q=80', alt: 'نموذج توضيحي لمطبخ حديث' },
  { src: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=80', alt: 'نموذج توضيحي لمشروع سكني' },
]

// ----------------------------------------------------------------------------
// أنواع المشاريع لنموذج عرض السعر
// ----------------------------------------------------------------------------
export const projectTypes: string[] = [
  'بناء منزل / فيلا',
  'مقاولات عامة',
  'أعمال خرسانية',
  'تشطيبات داخلية',
  'تشطيبات خارجية',
  'ترميم وصيانة',
  'بلاط ودهانات',
  'كهرباء وسباكة',
  'مشروع تجاري',
  'أخرى',
]

export const budgetRanges: string[] = [
  'أقل من 5 مليون',
  '5 - 15 مليون',
  '15 - 50 مليون',
  'أكثر من 50 مليون',
  'غير محدد',
]

// Hero background image (replaceable)
export const heroImage =
  'https://images.unsplash.com/photo-1541976590-713941681591?auto=format&fit=crop&w=2000&q=80'

// About section image (replaceable)
export const aboutImage =
  'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1400&q=80'
